import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { ReactTabulator } from "react-tabulator";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "../Modal";
import Loader from "../Loader/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export default function UserTable() {
  const [tableData, setTableData] = useState("");
  const [selectedRow, setSelectedRow] = useState();
  let userTableColumns = [
    {
      title: "مشخصه کاربر",
      field: "KMO",
    },
    {
      title: "موبایل",
      field: "MOB",
    },
    {
      title: "سطح دسترسی",
      field: "VZ",
    },
  ];

  useEffect(() => {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/user/`,
      params: { table: "" },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setTableData(response.data);
    });
  }, []);

  const tableRef = useRef(null);

  function rowClickHandler(e, row) {
    row.getTable().getSelectedRows().length === 0
      ? setSelectedRow()
      : setSelectedRow(row);
  }

  const [newUserModalIsOpen, setNewUserModalIsOpen] = useState(false);
  function newUserModalCallbackHandler({ isOpen }) {
    setNewUserModalIsOpen(isOpen);
  }
  const changePassModalFormSubmitHandler = (e) => {
    e.preventDefault();
    const passData = {
      type: "change",
      user: selectedRow.getData()["KMO"],
      newPassword: newPassRef.current.value,
      newPasswordRepeat: repeatNewPassRef.current.value,
      oldPassword: oldPassRef.current.value,
    };
    axios({
      method: "put",
      url: `${localStorage.getItem("apiUrl")}/password/`,
      data: passData,
    }).then((response) => {
      if (response.statusText === "OK") {
        toast.success("رمز عبور با موفقیت تغییر کرد");
        setchangePassModalIsOpen(false);
      } else {
        toast.error("لطفا مجددا تلاش کنید");
      }
    });
  };
  function newUserModalFormSubmitHandler(e) {
    e.preventDefault();
    let formData = new FormData(e.target);

    const sendNewUserModalFormData = axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/user/`,
      data: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      var rowData = {};
      formData.forEach(function (value, key) {
        rowData[key] = value;
      });
      tableRef.current.table.addRow(rowData);
      setNewUserModalIsOpen(false);
    });

    toast.promise(sendNewUserModalFormData, {
      pending: "در حال ارسال به سرور",
      success: "ثبت کاربر با موفقیت انجام شد",
      error: "ثبت کاربر با مشکل مواجه شد",
    });
  }

  const editUserFormRef = useRef(null);
  function changePasswordHandler() {
    setchangePassModalIsOpen(true);
  }
  function editUserHandler() {
    const getUserInfoRequest = axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/user/`,
      params: { user: selectedRow.getData()["KMO"] },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setEditUserModalIsOpen(true);
      let form = editUserFormRef.current;
      for (const key in response.data) {
        form[key].value = response.data[key];
      }
    });

    toast.promise(getUserInfoRequest, {
      pending: "در حال دریافت اطلاعات کاربر",
      success: "اطلاعات کاربر با موفقیت دریافت شد",
      error: "دریافت اطلاعات کاربر با مشکل مواجه شد",
    });
  }
  const [editUserModalIsOpen, setEditUserModalIsOpen] = useState(false);
  const [changePassModalIsOpen, setchangePassModalIsOpen] = useState(false);
  function changePassModalCallbackHandler({ isOpen }) {
    setchangePassModalIsOpen(isOpen);
  }
  function editUserModalCallbackHandler({ isOpen }) {
    setEditUserModalIsOpen(isOpen);
  }
  function editUserModalFormSubmitHandler(e) {
    e.preventDefault();
    let formData = new FormData(e.target);

    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });

    const sendEditUserModalFormData = axios({
      method: "PUT",
      url: `${localStorage.getItem("apiUrl")}/user/`,
      params: { user: formData.get("KMO") },
      data: object,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      var rowData = {};
      formData.forEach(function (value, key) {
        if (key === "KMO" || key === "MOB" || key === "VZ") {
          if (key === "VZ") {
            value === "1"
              ? (value = "به همه رکوردها")
              : (value = "فقط به رکوردهای خودش");
          }
          rowData[key] = value;
        }
      });
      selectedRow.update(rowData);
      editUserFormRef.current.reset();
      setEditUserModalIsOpen(false);
    });

    toast.promise(sendEditUserModalFormData, {
      pending: "در حال ارسال به سرور",
      success: "ویرایش اطلاعات با موفقیت انجام شد",
      error: "ویرایش اطلاعات با مشکل مواجه شد",
    });
  }

  function toggle(e) {
    let checkboxes = userAccessFormRef.current.querySelectorAll("input");
    for (var checkbox of checkboxes) checkbox.checked = e.target.checked;
  }
  const userAccessFormRef = useRef(null);
  const [accessModalContent, setAccessModalContent] = useState("");
  function userAccessHandler() {
    const getUserAccessInfoRequest = axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/permissions/`,
      params: { user: selectedRow.getData()["KMO"] },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      let accessModalContentTemp = (
        <>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={toggle}
            />
            <label className="form-check-label  mr-3">انتخاب همه</label>
          </div>
          <form>
            <legend>دسترسی های کلی</legend>
            <div className="form-group">
              {response.data["constants"].map(
                ({ EnName, FaLabel, value }, index) => (
                  <div className="form-check" key={index}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`constantsAccess${index}`}
                      name={FaLabel}
                      defaultChecked={value}
                    />
                    <label
                      className="form-check-label  mr-3"
                      htmlFor={`constantsAccess${index}`}
                    >
                      {FaLabel}
                    </label>
                  </div>
                )
              )}
            </div>
          </form>
          <form>
            <legend>فهرست ها</legend>
            <div className="form-group">
              {response.data["List"].map(
                ({ EnName, FaLabel, value }, index) => (
                  <div className="form-check" key={index}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`listAccess${index}`}
                      name={FaLabel}
                      defaultChecked={value}
                    />
                    <label
                      className="form-check-label  mr-3"
                      htmlFor={`listAccess${index}`}
                    >
                      {FaLabel}
                    </label>
                  </div>
                )
              )}
            </div>
          </form>
          <form>
            <legend>عملیات ها</legend>
            <div className="form-group">
              {response.data["operation"].map(
                ({ EnName, FaLabel, value }, index) => (
                  <div className="form-check" key={index}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`operationAccess${index}`}
                      name={FaLabel}
                      defaultChecked={value}
                    />
                    <label
                      className="form-check-label  mr-3"
                      htmlFor={`operationAccess${index}`}
                    >
                      {FaLabel}
                    </label>
                  </div>
                )
              )}
            </div>
          </form>
        </>
      );
      setAccessModalContent(accessModalContentTemp);
      setUserAccessModalIsOpen(true);
    });

    toast.promise(getUserAccessInfoRequest, {
      pending: "در حال دریافت  دسترسی های کاربر",
      success: " دسترسی ها با موفقیت دریافت شد",
      error: "دریافت  دسترسی ها با مشکل مواجه شد",
    });
  }
  const [userAccessModalIsOpen, setUserAccessModalIsOpen] = useState(false);
  function userAccessModalCallbackHandler({ isOpen }) {
    setUserAccessModalIsOpen(isOpen);
  }
  function userAccessModalFormSubmitHandler(e) {
    e.preventDefault();
    let formcontainer = userAccessFormRef.current;
    let data = [];
    let sets = formcontainer.querySelectorAll("form");
    for (let set of sets) {
      var formData = new FormData(set);
      var object = {};
      object.title = set.querySelector("legend").innerText;
      formData.forEach(function (value, key) {
        object[key] = value;
      });
      data.push(object);
    }

    const sendEditUserModalFormData = axios({
      method: "POST",
      url: `${localStorage.getItem("apiUrl")}/permissions/`,
      params: { user: selectedRow.getData()["KMO"] },
      data: data,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      // userAccessFormRef.current.reset();
      setEditUserModalIsOpen(false);
    });

    toast.promise(sendEditUserModalFormData, {
      pending: "در حال ارسال به سرور",
      success: "ویرایش دسترسی ها با موفقیت انجام شد",
      error: "ویرایش دسترسی ها با مشکل مواجه شد",
    });
  }

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  function userTempRemoveHandler() {
    let toastContext = (
      <span>
        اگر مطمئن نیستید
        <button
          className="remove-cancel-btn"
          onClick={() => {
            source.cancel("Operation canceled by the user.");
          }}
        >
          لغو
        </button>
        کنید
      </span>
    );
    selectedRow !== undefined &&
      toast.warn(toastContext, {
        autoClose: 3000,
        onClose: () => userRemoveHandler(selectedRow),
      });
  }
  function userRemoveHandler(row) {
    const removeUserRequest = axios({
      method: "DELETE",
      url: `${localStorage.getItem("apiUrl")}/user/`,
      params: { user: row.getData()["KMO"] },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      cancelToken: source.token,
    }).then(() => {
      row.delete();
      setSelectedRow();
    });

    toast.promise(removeUserRequest, {
      pending: "در حال حذف کاربر از سرور",
      success: "کاربر با موفقیت حذف شد",
      error: "حذف کاربر موفقیت آمیز نبود",
    });
  }
  const newPassRef = useRef(null);
  const oldPassRef = useRef(null);
  const repeatNewPassRef = useRef(null);

  return (
    <>
      <ReactTabulator
        ref={tableRef}
        data={tableData}
        columns={userTableColumns}
        options={{ selectable: 1 }}
        events={{ rowClick: rowClickHandler }}
      />
      {tableData === undefined && <Loader />}

      <div className="mt-5 d-flex justify-content-center ">
        <div className="row">
          <button
            className="btn btn-primary mx-1 mb-1"
            onClick={() => setNewUserModalIsOpen(true)}
            disabled={tableData === undefined}
          >
            افزودن کاربر
          </button>
          <button
            className="btn btn-primary mx-1 mb-1"
            onClick={userAccessHandler}
            disabled={selectedRow === undefined}
          >
            دسترسی های کاربر
          </button>
          <button
            className="btn btn-primary mx-1 mb-1"
            onClick={editUserHandler}
            disabled={selectedRow === undefined}
          >
            ویرایش
          </button>
          <button
            className="btn btn-primary mx-1 mb-1"
            onClick={changePasswordHandler}
            disabled={selectedRow === undefined}
          >
            تغییر رمز
          </button>
          <button
            className="btn btn-danger mx-1 mb-1"
            onClick={userTempRemoveHandler}
            disabled={selectedRow === undefined}
          >
            حذف
          </button>
        </div>
      </div>
      <Modal
        isOpen={changePassModalIsOpen}
        modalCallback={changePassModalCallbackHandler}
      >
        <ModalHeader title="تغییر رمز عبور" />
        <ModalBody>
          <form
            id="changePassModalFormRef"
            onSubmit={changePassModalFormSubmitHandler}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-8">
                <div className="form-group">
                  <label>رمز عبور قبلی کاربر</label>
                  <input
                    type="password"
                    className="form-control"
                    name="oldpass"
                    required
                    autoComplete="off"
                    ref={oldPassRef}
                  />
                </div>
              </div>
              <div className="col-md-8">
                <div className="form-group">
                  <label>رمز عبور جدید </label>
                  <input
                    type="password"
                    minlength="8"
                    className="form-control"
                    name="oldpass"
                    required
                    autoComplete="off"
                    ref={newPassRef}
                  />
                </div>
              </div>
              <div className="col-md-8">
                <div className="form-group">
                  <label>تکرار رمز عبور جدید </label>
                  <input
                    type="password"
                    className="form-control"
                    minlength="8"
                    name="oldpass"
                    required
                    autoComplete="off"
                    ref={repeatNewPassRef}
                  />
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <input
            type="submit"
            form="changePassModalFormRef"
            value="ثبت"
            className="btn btn-primary  "
          />
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={newUserModalIsOpen}
        modalCallback={newUserModalCallbackHandler}
      >
        <ModalHeader title="تعریف کاربر جدید" />
        <ModalBody>
          <form
            id="newUserModalFormRef"
            onSubmit={newUserModalFormSubmitHandler}
          >
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>مشخصه کاربر</label>
                  <input
                    type="text"
                    className="form-control"
                    name="KMO"
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>پسورد</label>
                  <input
                    type="password"
                    className="form-control"
                    name="PASS"
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>موبایل</label>
                  <input
                    type="text"
                    className="form-control"
                    name="MOB"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>تلفن</label>
                  <input
                    type="text"
                    className="form-control"
                    name="TEL"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>سوال(یکی از سوالات را انتخاب کنید)</label>
                  <select
                    className="form-control"
                    id="sec-que"
                    name="QU"
                    required
                  >
                    <option>سوال ۱</option>
                    <option>سوال ۲</option>
                    <option>سوال ۳</option>
                    <option>سوال ۴</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>پاسخ</label>
                  <input
                    type="text"
                    className="form-control"
                    name="AN"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>سطح دسترسی</label>
                  <select
                    className="form-control"
                    id="access"
                    name="VZ"
                    required
                  >
                    <option value={2}>فقط به رکوردهای خودش </option>
                    <option value={1}>به همه رکوردها</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <input
            type="submit"
            form="newUserModalFormRef"
            value="ثبت"
            className="btn btn-primary  "
          />
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={editUserModalIsOpen}
        modalCallback={editUserModalCallbackHandler}
      >
        <ModalHeader title="ویرایش کاربر" />
        <ModalBody>
          <form
            id="editUserModalForm"
            ref={editUserFormRef}
            onSubmit={editUserModalFormSubmitHandler}
          >
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>مشخصه کابر</label>
                  <input
                    type="text"
                    className="form-control"
                    name="KMO"
                    required
                    readOnly
                  />
                </div>
              </div>
              {/* <div className="col-md-6">
                <div className="form-group">
                  <label>پسورد</label>
                  <input
                    type="password"
                    className="form-control"
                    name="PASS"
                    required
                  />
                </div>
              </div> */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>موبایل</label>
                  <input
                    type="text"
                    className="form-control"
                    name="MOB"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>تلفن</label>
                  <input
                    type="text"
                    className="form-control"
                    name="TEL"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>سوال(یکی از سوالات را انتخاب کنید)</label>
                  <select
                    className="form-control"
                    id="sec-que"
                    name="QU"
                    required
                  >
                    <option>سوال ۱</option>
                    <option>سوال ۲</option>
                    <option>سوال ۳</option>
                    <option>سوال ۴</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>پاسخ</label>
                  <input
                    type="text"
                    className="form-control"
                    name="AN"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>سطح دسترسی</label>
                  <select
                    className="form-control"
                    id="access"
                    name="VZ"
                    required
                  >
                    <option value={2}>فقط به رکوردهای خودش </option>
                    <option value={1}>به همه رکوردها</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <input
            type="submit"
            className="btn btn-primary"
            form="editUserModalForm"
            value="ثبت"
          />
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={userAccessModalIsOpen}
        modalCallback={userAccessModalCallbackHandler}
      >
        <ModalHeader title="دسترسی های کاربر" />
        <ModalBody>
          <div
            id="userAccessModalForm"
            ref={userAccessFormRef}
            // onSubmit={userAccessModalFormSubmitHandler}
          >
            {accessModalContent}
          </div>
        </ModalBody>
        <ModalFooter>
          <input
            type="submit"
            className="btn btn-primary"
            form="userAccessModalForm"
            value="ثبت"
            onClick={userAccessModalFormSubmitHandler}
          />
        </ModalFooter>
      </Modal>
    </>
  );
}
